module.exports = __webpack_public_path__ + "img/about-pic2.7710fa82.png";